import { GetLongTermCustomerForecastResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import {
  ILongTermCustomerForecastResult,
  ILongTermCustomerForecast,
  IPagingOptions,
} from '@/recommendOrderModule/domains/entities/longTermCustomerForecast';

/**
 * 長期客先内示のAdapter
 */
export class LongTermCustomerForecastAdapter {
  /**
   * APIのレスポンスをフロントエンドの型に変換する
   * @param response - APIレスポンス
   * @returns フロントエンドの型に変換したデータ
   */
  public static adapt(response: GetLongTermCustomerForecastResponseAllOfResult): ILongTermCustomerForecastResult {
    const convertedData: ILongTermCustomerForecast[] = response.data.map((d) => ({
      customerForecastId: d.customerForecastId,
      customerForecastResponsibleUserIdHistory: d.customerForecastResponsibleUserIdHistory,
      createdSupplierForecast: d.createdSupplierForecast,
      customerForecastReceivedYear: d.customerForecastReceivedYear,
      customerForecastReceivedMonth: d.customerForecastReceivedMonth,
      customerForecastTargetYear: d.customerForecastTargetYear,
      customerForecastTargetMonth: d.customerForecastTargetMonth,
      customerForecastAmount: d.customerForecastAmount,
      updateAt: d.updateAt,
    }));

    const convertedPagingOptions: IPagingOptions = {
      count: response.data.length,
      total: response.data.length, // APIからtotalが返されないため、取得件数をtotalとする
      page: 1, // APIからpageが返されないため、1で固定
      items: 100, // limit値
    };

    return {
      data: convertedData,
      pagingOptions: convertedPagingOptions,
    };
  }
}
